var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Basic = require("../../../../elements/Basic");

var _Logos = require("../../Basic/Logos");

var _ColorHelper = require("../Utils/ColorHelper");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Table/Standings/StandingsRowBuilder.js";

var StandingsRowBuilder = function StandingsRowBuilder(_ref) {
  var item = _ref.item;
  return [_react.default.createElement(_Basic.Text, {
    tableWidth: 7 / 100,
    maxWidth: 45,
    columnStyling: {
      bg: (0, _ColorHelper.getBackgroundColorOfQualifier)(item.teamQualification),
      center: true
    },
    color: (0, _ColorHelper.getTextColorOfQualifier)(item.teamQualification),
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7,
      columnNumber: 5
    }
  }, item.position), _react.default.createElement(_Basic.View, {
    maxWidth: 50,
    center: true,
    isFlex: true,
    tableWidth: 8 / 100,
    columnStyling: {
      center: true,
      my: 0,
      mx: 0
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 5
    }
  }, _react.default.createElement(_Logos.TeamLogo, {
    size: 20,
    my: 0,
    mx: 0,
    src: item.soccerTeam.imageUrl,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 9
    }
  })), _react.default.createElement(_Basic.Column, {
    columnStyling: {
      flexing: true,
      justifyContent: 'center',
      alignItems: 'flex-start',
      minWidth: 0
    },
    isFlex: true,
    width: "100%",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 5
    }
  }, _react.default.createElement(_Basic.Text, {
    pl: 10,
    numberOfLines: 1,
    bold: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 9
    }
  }, item.soccerTeam.shortName || item.soccerTeam.name)), _react.default.createElement(_Basic.Text, {
    tableWidth: 8 / 100,
    maxWidth: 40,
    columnStyling: {
      center: true
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 5
    }
  }, item.played), _react.default.createElement(_Basic.Text, {
    tableWidth: 6 / 100,
    maxWidth: 40,
    columnStyling: {
      center: true
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 5
    }
  }, item.won), _react.default.createElement(_Basic.Text, {
    tableWidth: 6 / 100,
    maxWidth: 40,
    columnStyling: {
      center: true
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 5
    }
  }, item.drawn), _react.default.createElement(_Basic.Text, {
    tableWidth: 6 / 100,
    maxWidth: 40,
    columnStyling: {
      center: true
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 5
    }
  }, item.lost), _react.default.createElement(_Basic.Text, {
    tableWidth: 14 / 100,
    maxWidth: 90,
    columnStyling: {
      center: true
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 5
    }
  }, item.forValue, ":", item.againstValue), _react.default.createElement(_Basic.Text, {
    tableWidth: 8 / 100,
    maxWidth: 40,
    columnStyling: {
      center: true
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 5
    }
  }, item.forValue - item.againstValue), _react.default.createElement(_Basic.Text, {
    tableWidth: 8 / 100,
    maxWidth: 55,
    bold: true,
    columnStyling: {
      center: true
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 5
    }
  }, item.points)];
};

var _default = StandingsRowBuilder;
exports.default = _default;